import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./CSS/Booster.css";
import Store from "../Store/Store";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { Input } from "@mui/material";
import { FormControl, Typography } from "@material-ui/core";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

import { InputAdornment } from "@material-ui/core";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import {
  SET_FETCH_TAG_VALUE_CONTROL,
  set_booster_calis_dur,
  set_booster_tags,
  set_pumps_tags,
  set_external_trend_info,
  set_tag_values,
} from "../Action/Action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

let state_2 = [
  {
    "BOOSTER KAT 1 ": [
      { text: "Su Çıkış Sıcaklığı", tagId: "953" },
      { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "997" },
      { text: "Çalışma Durumu", tagId: "1261" },
      { text: "Arıza Durumu", tagId: "1262" },
      { text: "Arıza Kodu", tagId: "2621" },
      { text: "Çalış Dur Komutu", tagId: "1437", type: "btn" },
      { text: "Booster 1 Akımı", tagId: "133" },
      { text: "Booster 1 Enerji Sarfiyatı", tagId: "134" },
    ],
  },
  {
    "BOOSTER KAT 1 (LOBI TARAFI) ": [
      { text: "Su Çıkış Sıcaklığı", tagId: "972" },
      { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "1111" },
      { text: "Çalışma Durumu", tagId: "1337" },
      { text: "Arıza Durumu", tagId: "7231" },
      { text: "Arıza Kodu", tagId: "2697" },
      { text: "Çalış Dur Komutu", tagId: "1456", type: "btn" },
      { text: "Booster 1 Akımı", tagId: "8730" },
      { text: "Booster 1 Enerji Sarfiyatı", tagId: "8729" },
    ],
  },
  {
    "BOOSTER KAT 2": [
      { text: "Su Çıkış Sıcaklığı", tagId: "5054" },
      { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "5238" },
      { text: "Çalışma Durumu", tagId: "5446" },
      { text: "Arıza Durumu", tagId: "5447" },
      { text: "Arıza Kodu", tagId: "6726" },
      { text: "Çalış Dur Komutu", tagId: "5538", type: "btn" },
      { text: "Booster 2 Akımı", tagId: "139" },
      { text: "Booster 2 Enerji Sarfiyatı", tagId: "135" },
    ],
  },
  {
    "BOOSTER KAT 3": [
      { text: "Su Çıkış Sıcaklığı", tagId: "5041" },
      { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "5160" },
      { text: "Çalışma Durumu", tagId: "5394" },
      { text: "Arıza Durumu", tagId: "5395" },
      { text: "Arıza Kodu", tagId: "6674" },
      { text: "Çalış Dur Komutu", tagId: "5525", type: "btn" },
      { text: "Booster 3 Akımı", tagId: "140" },
      { text: "Booster 3 Enerji Sarfiyatı", tagId: "136" },
    ],
  },
  {
    "BOOSTER KAT 4": [
      { text: "Su Çıkış Sıcaklığı", tagId: "5069" },
      { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "5328" },
      { text: "Çalışma Durumu", tagId: "5506" },
      { text: "Arıza Durumu", tagId: "5507" },
      { text: "Arıza Kodu", tagId: "6786" },
      { text: "Çalış Dur Komutu", tagId: "5553", type: "btn" },
      { text: "Booster 4 Akımı", tagId: "141" },

      { text: "Booster 4 Enerji Sarfiyatı", tagId: "137" },
    ],
  },
  {
    "BOOSTER KAT 5 ": [
      { text: "Su Çıkış Sıcaklığı", tagId: "5026" },
      { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "5070" },
      { text: "Çalışma Durumu", tagId: "5334" },
      { text: "Arıza Durumu", tagId: "5335" },
      { text: "Arıza Kodu", tagId: "6614" },
      { text: "Çalış Dur Komutu", tagId: "5510", type: "btn" },
      { text: "Booster 5 Akımı", tagId: "142" },
      { text: "Booster 5 Enerji Sarfiyatı", tagId: "138" },
    ],
  },
];

const inital_func = () => {
  const obj__ = [];
  const obj2__ = [];

  state_2.forEach((item) => {
    Object.entries(item).forEach(([key, value]) => {
      value.forEach((item3) => {
        obj2__.push({ tagId: item3.tagId });
      });
    });
  });

  const uniqueTagIds = Array.from(new Set(obj2__.map((item) => item.tagId)));

  const uniqueTags = uniqueTagIds.map((tagId) => ({ tagId }));

  setInterval(() => {
    const fetch_tag_values = async () => {
      if (window.location.pathname === "/booster") {
        try {
          const request = await fetch(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            {
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
              },
              method: "POST",
              body: JSON.stringify(uniqueTags),
            }
          );
          const response = await request.json();

          console.log(response);

          Store.dispatch(set_booster_tags(response));
        } catch (err) {
          console.error("Error fetching tag values:", err);
        } finally {
          Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
        }
      }
    };
    fetch_tag_values();
  }, 2000);
};

setTimeout(() => {
  inital_func();
}, 2000);

const Booster = (props) => {
  const [tag_values, Set_tag_values] = useState([]);

  const [state, SetState] = useState(state_2);

  const [calis_dur, Set_calis_dur] = useState({});

  const history = useHistory();

  const maxValueByType = {
    TÜKETİM: 15000,
    GÜÇ: 10000,
    "L1 GERİLİM": 240,
    "L2 GERİLİM": 240,
    "L3 GERİLİM": 240,
    "L1 AKIM": 250,
    "L2 AKIM": 250,
    "L3 AKIM": 250,
    "GÜÇ FAKTÖRÜ": 1,
    "REAKTIF GÜÇ": 1000,
    FREKANS: 100,
  };
  const minValueByType = {
    "L1 GERİLİM": 210,
    "L2 GERİLİM": 210,
    "L3 GERİLİM": 210,
  };

  useEffect(() => {
    Set_tag_values(props.tag_values);
  }, [props.tag_values]);

  const [calis_deger, Set_calis_deger] = useState("1 ");

  useEffect(() => {
    const componentDidMount = () => {
      // Boş bir set oluşturuyoruz
      const tagIdSet = new Set();

      var obj__ = [];
      var obj2__ = [];

      // state_2 içindeki tagId'leri alıyoruz
      state_2.forEach((item) => {
        Object.entries(item).forEach((a) => {
          obj__.push(a[1]);
        });
      });

      obj__.forEach((item2) => {
        item2.forEach((item3) => {
          if (item3.tagId) {
            tagIdSet.add(item3.tagId); // TagId'yi Set'e ekliyoruz
          }
        });
      });

      // Set'ten benzersiz tagId'leri alıyoruz
      const uniqueTagIds = Array.from(tagIdSet);

      var newdata = [];

      uniqueTagIds.forEach((tagId) => {
        const matchingTag = props.tag_values.find(
          (item) => item.tagId === tagId
        );
        if (matchingTag) {
          newdata.push({
            tagId: matchingTag.tagId,
            tagValue: matchingTag.tag_value,
          });
        }
      });

      Set_tag_values(newdata);

      var tag_values_calis_dur = [];
      var title = [];
      var newdata = {};

      state.map((item, index) => {
        var obj_ = [];
        Object.entries(item).forEach((a) => {
          title.push(a[0]);
          obj_.push(a[1]);
        });
        obj_[0].forEach((item_) => {
          props.booster_tags.forEach((item2) => {
            if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Çalışma Durumu"
            ) {
              console.log(item2);
              tag_values_calis_dur.push(item2.tagValue);
            }
          });
        });
      });

      console.log("ÇALIŞ DUR DEĞERLER = ", tag_values_calis_dur);

      for (let i = 0; i < title.length; i++) {
        newdata[title[i]] =
          tag_values_calis_dur[i] !== undefined
            ? (Number(tag_values_calis_dur[i].trim()) === 1 ? "1" : "0")
            : "";
      }

      console.log(newdata);

      Set_calis_deger(newdata);
    };

    componentDidMount();
  }, [props.booster_tags]);

  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {}
  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);


      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {}
  };

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      console.log(newObj);
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };

  const getBackgroundStyle = (type, valueString) => {
    const numericValue = parseFloat(valueString);
    const maxValue = maxValueByType[type] || 1;
    const minValue = minValueByType[type] || 0;
    const adjustedValue = Math.max(numericValue - minValue, 0);
    const adjustedMaxValue = maxValue - minValue;
    const ratio = Math.min(Math.max(adjustedValue / adjustedMaxValue, 0), 1);
    if (type.includes("Çalışma Durumu")) {
      return {
        background: `linear-gradient(to right, rgb(124,252,0) ${
          ratio * 100
        }%, white ${ratio * 100}%)`,
      };
    } else if (type.includes("Arıza Durumu") || type.includes("Alarm")) {
      return {
        background: `linear-gradient(to right, 	rgb(255, 49, 49) ${
          ratio * 100
        }%, white ${ratio * 100}%)`,
      };
    }
    return {
      background: `linear-gradient(to right, rgb(237, 188, 69) ${
        ratio * 100
      }%, white ${ratio * 100}%)`,
    };
  };

  const static_list = [1456, 1457, 5538, 5525, 5553, 5510];

  useEffect(() => {
    if (props.booster_tags2.length < 1) {
      var obj_new = {
        0: { TagId: 0, TagValue: 0 },
        1: { TagId: 0, TagValue: 0 },
        2: { TagId: 0, TagValue: 0 },
        3: { TagId: 0, TagValue: 0 },
        4: { TagId: 0, TagValue: 0 },
        5: { TagId: 0, TagValue: 0 },
      };

      let new_values = [];

      let i = 0;
      while (i < props.booster_tags.length) {
        var tagId_;
        for (let j of static_list) {
          if (
            props.booster_tags[i].tagId === String(j) &&
            tagId_ !== String(j)
          ) {
            tagId_ = String(j);
            new_values.push(props.booster_tags[i].tagValue);
          }
        }
        i++;
      }

      for (let k = 0; k < new_values.length; k++) {
        obj_new[k.toString()] = new_values[k];
      }

      var last_arr = [];
      last_arr.push(obj_new);
      Store.dispatch(set_booster_calis_dur(last_arr));
    }
  }, []);

  const loadingStyle = {
    background: "linear-gradient(to right, #f0f0f0 50%, white 50%)",
  };

  const [err, Set_err] = useState("");
  const [info, Set_info] = useState("");

  async function AddNotification(obj) {
    const req = await fetch(
      "https://app-rmmsapi.azurewebsites.net/api/tags/AddNotification",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "POST",
        body: JSON.stringify(obj),
      }
    );
    const response = await req.json();
    if (req.status === 200) {
    }
  }

  async function send_req_calıs_dur(list_) {
    let tagId__ = list_.TagId;
    let confirmed_ = 0;
    let message;
    let date_ = new Date().toJSON();
    let status_;

    const req_ = await fetch(
      "https://app-rmmscmdapi.azurewebsites.net/api/cmd/SetValue",
      {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(list_),
      }
    );

    const response = await req_.json();

    if (req_.status === 200 && response) {
      Set_info("Başarıyla Kaydedildi");
      message = "Başarıyla Kaydedildi";
      status_ = "200";
    } else {
      Set_err("Bir hata oluştu");
      message = "Bir hata oluştu";
      status_ = "400";
    }

    AddNotification({
      Message: message,
      StatusCode: status_,
      TagId: tagId__,
      Confirm_: confirmed_,
      Date: date_,
      TagName: "",
      CompanyID: props.company_id,
      tagValue: list_.TagValue,
    });
  }

  // async function send_req_calıs_dur(list_) {
  //
  //   let tagId__ = list_.TagId;
  //   let confirmed_ = 0;
  //   let message;
  //   let date_ = new Date().toJSON();
  //   let status_;

  //   console.log("Gönderilen Veri:", list_); // Gönderilen veriyi konsola yazdırır

  //   const req_ = await fetch("https://jsonplaceholder.typicode.com/posts", {
  //     method: "POST",
  //     headers: {
  //       accept: "application/json",
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(list_),
  //   });

  //   console.log("API İsteği:", req_); // API isteğini konsola yazdırır

  //   const response = await req_.json();
  //   console.log("API Yanıtı:", response); // API yanıtını konsola yazdırır

  //   if (req_.status === 201) {
  //     // JSONPlaceholder için başarı kodu 201'dir
  //     Set_info("Başarıyla Kaydedildi (Fake API)");
  //     message = "Başarıyla Kaydedildi (Fake API)";
  //     status_ = "200";
  //   } else {
  //     Set_err("Bir hata oluştu (Fake API)");
  //     message = "Bir hata oluştu (Fake API)";
  //     status_ = "400";
  //   }

  //   AddNotification({
  //     Message: message,
  //     StatusCode: status_,
  //     TagId: tagId__,
  //     Confirm_: confirmed_,
  //     Date: date_,
  //     TagName: "",
  //     CompanyID: props.company_id,
  //     tagValue: list_.TagValue,
  //   });
  // }

  useEffect(() => {
    // Pop up Hallet
    document
      .querySelector(".alert_info_err_popup")
      .classList.toggle("alert_info_err_popup_active");

    if (err !== "") {
      setTimeout(() => {
        //Pop up ı hallet
        document
          .querySelector(".alert_info_err_popup")
          .classList.toggle("alert_info_err_popup_active");

        Set_err("");
      }, 4000);
    }
  }, [err]);

  useEffect(() => {
    // Pop up Hallet
    document
      .querySelector(".alert_info_err_popup")
      .classList.toggle("alert_info_err_popup_active");
    if (info !== "") {
      setTimeout(() => {
        //Pop up ı hallet
        document
          .querySelector(".alert_info_err_popup")
          .classList.toggle("alert_info_err_popup_active");

        Set_info("");
      }, 4000);
    }
  }, [info]);

  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  const [popup, setPopup] = useState({
    visible: false,
    title: "",
    calisDurumu: "",
    SuCikisSetDegeri: "",
    originalCalisDurumu: "",
    originalSuCikisSetDegeri: "",
  });

  const handleRightClick = (e, title, tags, mainTitle) => {
    e.preventDefault();

    const calisDurumuTag = tags.find((tag) =>
      tag.text.includes("Çalışma Durumu")
    );
    const SuCikisSetDegeriTag = tags.find((tag) =>
      tag.text.includes("Su Çıkış Sıcaklığı Set Değeri")
    );
    const calisDurKomutuTag = tags.find((tag) =>
      tag.text.includes("Çalış Dur Komutu")
    );

    const calisDurumuTagId = calisDurumuTag?.tagId;
    const SuCikisSetDegeriTagId = SuCikisSetDegeriTag?.tagId;
    const calisDurKomutuTagId = calisDurKomutuTag?.tagId;

    const calisDurumu =
      props.booster_tags.find(
        (tag) => String(tag.tagId) === String(calisDurumuTagId)
      )?.tagValue || "N/A";
    const SuCikisSetDegeri =
      props.booster_tags.find(
        (tag) => String(tag.tagId) === String(SuCikisSetDegeriTagId)
      )?.tagValue || "N/A";

    setPopup({
      visible: true,
      title: mainTitle,
      calisDurumu: calisDurumu.trim(),
      SuCikisSetDegeri: SuCikisSetDegeri.trim(),
      originalCalisDurumu: calisDurumu.trim(),
      originalSuCikisSetDegeri: SuCikisSetDegeri.trim(),
      calisDurumuTagId: calisDurumuTagId,
      SuCikisSetDegeriTagId: SuCikisSetDegeriTagId,
      calisDurKomutuTagId: calisDurKomutuTagId,
    });
  };

  const handleCalisDurumuChange = (event) => {
    const selectedValue = event.target.value;

    setPopup((prevPopup) => ({
      ...prevPopup,
      calisDurumu: selectedValue,
    }));
  };

  const handleSuCikisSetDegeriChange = (event) => {
    const newValue = event.target.value;
    setPopup((prevPopup) => ({
      ...prevPopup,
      SuCikisSetDegeri: newValue,
    }));
  };

  const handleCancelChanges = () => {
    setPopup((prevPopup) => ({
      ...prevPopup,
      calisDurumu: prevPopup.originalCalisDurumu,
      SuCikisSetDegeri: prevPopup.originalSuCikisSetDegeri,
    }));
  };

  const handleSaveChange = () => {
    const {
      calisDurumu,
      SuCikisSetDegeri,
      calisDurumuTagId,
      SuCikisSetDegeriTagId,
      calisDurKomutuTagId,
    } = popup;

    // Değişiklik yapıldı mı kontrol et
    const calisDurumuChanged = calisDurumu !== popup.originalCalisDurumu;
    const SuCikisSetDegeriChanged =
      SuCikisSetDegeri !== popup.originalSuCikisSetDegeri;

    // Sadece değişiklik varsa kaydetme işlemi yap
    if (calisDurumuChanged || SuCikisSetDegeriChanged) {
      if (calisDurKomutuTagId && calisDurumuChanged) {
        const newTagValue = calisDurumu === "1" ? "1 " : "0 ";

        const payload = {
          TagId: String(calisDurKomutuTagId),
          TagValue: newTagValue,
        };

        console.log("Çalış Dur Komutu gönderiliyor:", payload);
        send_req_calıs_dur(payload); // Veriyi gönder
      }

      if (SuCikisSetDegeriTagId && SuCikisSetDegeriChanged) {
        const payload = {
          TagId: String(SuCikisSetDegeriTagId),
          TagValue: String(SuCikisSetDegeri).trim(),
        };

        console.log("Su Çıkış Set Değeri gönderiliyor:", payload);
        send_req_calıs_dur(payload); // Veriyi gönder
      }

      // Pop-up kapatılabilir
      setPopup({
        ...popup,
        visible: false,
      });
    } else {
      // Değişiklik yapılmadı, pop-up kapatılabilir
      setPopup({
        ...popup,
        visible: false,
      });
    }
  };

  const closePopup = () => {
    setPopup({
      visible: false,
      title: "",
      calisDurumu: "",
      SuCikisSetDegeri: "",
      originalCalisDurumu: "",
      originalSuCikisSetDegeri: "",
    });
  };

  return (
    <div className="booster-page-div">
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <div></div>
      <section className="section_booster">
        <Link to="/hot_water_system">
          <Button
            style={{
              position: "absolute",
              color: "black",
              top: "12%",
              left: "18%",
              zIndex: 9999999,
              borderRadius: "15px",
              backgroundColor: "#fff",
              border: "3px solid rgba(238, 200, 108, 0.99)",
              fontWeight: 600,
            }}
            className=" movebuttons-booster"
            variant="contained"
          >
            Geri
          </Button>
        </Link>
        <div className="boostertop">
          <div>SU ISITICILARI</div>
        </div>

        <div
          style={{ position: "absolute" }}
          className={`alert_info_err_popup ${
            err !== "" ? "err" : info !== "" ? "info" : ""
          }`}
        >
          {err !== "" ? err : info !== "" ? info : ""}
        </div>

        <div className="bottom_booster">
          {state.map((item, index) => {
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              title.push(a[0]);
              obj_.push(a[1]);
            });

            var calisma_durumu_temp_state;

            return (
              <div className="rows">
                <div className="left">
                  <div></div>
                  <div className="lefttitle">
                    <button
                      className="leftbutton"
                      onClick={
                        (e) => handleRightClick(e, title[0], obj_[0], title[0]) // Ana başlık olan "Booster Kat 1", "Booster Kat 2" gibi title[0] değerini de geçiriyoruz
                      }
                    >
                      {" "}
                      {title[0]}{" "}
                    </button>
                  </div>
                </div>
                <div className="right">
                  <div className="right_top">
                    {obj_[0].map((x, index2) => {
                      if (x.text === "Çalış Dur Komutu") {
                        return null; // "Çalış Dur Komutu" için render yapmıyoruz.
                      }

                      // Sadece "Su Çıkış Sıcaklığı Set Değeri" ve "Çalışma Durumu" için tıklama olayı ekliyoruz
                      if (
                        x.text === "Su Çıkış Sıcaklığı Set Değeri" ||
                        x.text === "Çalışma Durumu"
                      ) {
                        return (
                          <div
                            className={x.class + " righttop"}
                            onClick={(e) =>
                              handleRightClick(e, x.text, obj_[0], title[0])
                            } // Ana başlık title[0]'ı handleRightClick'e ekliyoruz
                          >
                            {index2 === 6
                              ? x.text + " (A)"
                              : index2 === 7
                              ? x.text + " (kWh)"
                              : x.text}
                          </div>
                        );
                      }

                      // Diğer değerler için tıklama olayı eklenmez, sadece normal render işlemi yapılır
                      return (
                        <div className={x.class + " righttop"}>
                          {index2 === 6
                            ? x.text + " (A)"
                            : index2 === 7
                            ? x.text + " (kWh)"
                            : x.text}
                        </div>
                      );
                    })}
                  </div>

                  <div className="right_bottom">
                    {obj_[0].map((x, index3) => {
                      if (x.text === "Çalış Dur Komutu") {
                        return null; // "Çalış Dur Komutu" için render yapmıyoruz.
                      }

                      var değerler = props.booster_tags
                        .filter((a) => String(a.tagId) === String(x.tagId))
                        .map((b) => b.tagValue);

                      var değerler_eleman = değerler[0];
                      if (x.text.includes("Çalışma Durumu")) {
                        calisma_durumu_temp_state = değerler_eleman;
                      }

                      if (değerler.length > 1) {
                        değerler.pop();
                      }

                      var last_değer = String(değerler_eleman);
                      last_değer = last_değer.replaceAll(",", ".");

                      last_değer = Number(last_değer).toFixed(2);

                      const matchingTag = props.tag_list.find(tag => tag.tagId === x.tagId);

                          // Eğer eşleşen tag bulunduysa ve tagDecimal null değilse o değeri kullan, yoksa varsayılan 2 kullan
                          const decimalPlaces = matchingTag && matchingTag.tagDecimal !== null
                            ? Number(matchingTag.tagDecimal)
                            : 2;



                          last_değer = decimalPlaces !== 0 ? Number(last_değer).toFixed(decimalPlaces) : Number(last_değer).toFixed(2)

                      // Arıza Durumu için özel işlem
                      if (x.text.includes("Arıza Durumu")) {
                        last_değer =
                          String(last_değer) === "0.00" ? "NORMAL" : "ARIZA";
                      }

                      // Arıza Kodu için özel işlem
                      else if (x.text.includes("Arıza Kodu")) {
                        const arizaKoduText =
                          {
                            1: "NORMAL",
                            2: "OTHER ERRORS",
                            3: "REFRIGERATION SYSTEM FAULT",
                            4: "WATER SYSTEM ERROR",
                            5: "AIR SYSTEM ERROR",
                            6: "ELECTRONIC SYSTEM ERROR",
                            7: "SENSOR FAULT",
                            8: "COMMINICATION ERROR",
                            9: "SYSTEM ERROR",
                          }[değerler_eleman ? değerler_eleman.trim() : ""] ||
                          "BILINMEYEN";

                        last_değer = arizaKoduText;
                      } else if (x.text.includes("Çalışma Durumu")) {
                        last_değer =
                          String(last_değer) === "1.00" ? "ON" : "OFF";
                      } else if (
                        x.text.includes("Arıza Durumu") ||
                        x.text.includes("Alarm")
                      ) {
                        if (String(last_değer) === "1.00") {
                          last_değer = "ALARM";
                        } else {
                          last_değer = "ARIZA";
                        }
                      }

                      if (x.type) {
                        var new_obj = props.booster_tags[0];
                        if (new_obj !== undefined) {
                          Object.entries(new_obj).forEach((item) => {
                            if (item[0] === String(index)) {
                              calisma_durumu_temp_state = item[1];
                            }
                          });
                        }

                        return değerler.length > 0 ? (
                          değerler.map((değer) => (
                            <button
                              onClick={(e) => {
                                const yeniDeger =
                                  calis_deger[title[0]] === "1" ? "0" : "1";

                                Set_calis_deger((prevDeg) => ({
                                  ...prevDeg,
                                  [title[0]]: yeniDeger,
                                }));

                                e.target.textContent =
                                  yeniDeger === "1" ? "STOP" : "START";
                                e.target.parentElement.firstElementChild.nextElementSibling.nextElementSibling.textContent =
                                  yeniDeger === "1" ? "ON" : "OFF";
                                e.target.parentElement.firstElementChild.nextElementSibling.nextElementSibling.style.background =
                                  yeniDeger === "1"
                                    ? "rgb(124,252,0)"
                                    : "white";

                                var new_obj = props.booster_tags[0];
                                Object.entries(new_obj).forEach((item) => {
                                  if (item[0] === String(index)) {
                                    new_obj[String(index)] =
                                      yeniDeger === "1" ? "1 " : "0 ";
                                  }
                                });

                                Store.dispatch(
                                  set_booster_calis_dur(Array(new_obj))
                                );

                                var newobj2_ = {
                                  TagId: String(x.tagId), // Burada x.tagId kullanıyoruz
                                  TagValue: yeniDeger === "1" ? "1 " : "0 ",
                                };
                                send_req_calıs_dur(newobj2_);
                              }}
                              className="komut_btn_calis_dur"
                            >
                              {calis_deger[title[0]] === "1" ? "STOP" : "START"}
                            </button>
                          ))
                        ) : (
                          <div style={loadingStyle}>{"Veri Yükleniyor"}</div>
                        );
                      } else {
                        return değerler.length > 0 ? (
                          değerler.map((değer) => (
                            <div
                              onContextMenu={(e) => {
                                e.preventDefault();
                                const { clientX, clientY } = e;
                                var tagName = props.tag_list
                                  .filter((b) => b.tagId === x.tagId)
                                  .map((c) => c.tagName)[0];

                                document.querySelector(
                                  ".show_tagName"
                                ).innerHTML = tagName;

                                document
                                  .querySelector(".show_external_trend")
                                  .classList.toggle(
                                    "show_external_trend_active"
                                  );
                                document.querySelector(
                                  ".show_tagId"
                                ).innerHTML = x.tagId;
                                var popup = document.querySelector(
                                  ".show_external_trend"
                                );
                                const popupRect = popup.getBoundingClientRect();
                                const viewportWidth = window.innerWidth;
                                const viewportHeight = window.innerHeight;

                                let newX = clientX;
                                let newY = clientY;

                                if (newX + popupRect.width > viewportWidth) {
                                  newX = viewportWidth - popupRect.width;
                                }

                                if (newY + popupRect.height > viewportHeight) {
                                  newY = viewportHeight - popupRect.height;
                                }

                                if (newX < 0) {
                                  newX = 0;
                                }

                                if (newY < 0) {
                                  newY = 0;
                                }

                                popup.style.left = `${newX}px`;
                                popup.style.top = `${newY}px`;
                              }}
                              style={
                                calis_deger[title[0]] === "1" &&
                                (last_değer === "ON" || last_değer === "OFF")
                                  ? { backgroundColor: "rgb(124,252,0)" }
                                  : calis_deger[title[0]] === "0" &&
                                    (last_değer === "ON" ||
                                      last_değer === "OFF")
                                  ? { backgroundColor: "red", color: "white" }
                                  : last_değer === "ALARM"
                                  ? { backgroundColor: "red", color: "white" }
                                  : getBackgroundStyle(x.text, last_değer)
                              }
                            >
                              {last_değer === "ON" || last_değer === "OFF"
                                ? calis_deger[title[0]] === "1"
                                  ? "ON"
                                  : "OFF"
                                : last_değer}
                            </div>
                          ))
                        ) : (
                          <div style={loadingStyle}>{"Veri Yükleniyor"}</div>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>
            );
          })}
          {popup.visible && (
            <>
              {/* Arka planı karartan overlay */}
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 99999999, // Popup z-index'inden düşük olmalı
                }}
                onClick={closePopup} // Overlay'e tıklanırsa popup kapanır
              ></div>

              {/* Popup */}
              <div
                className="popup"
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "57%",
                  transform: "translate(-50%, -50%)",
                  background: "white",
                  border: "2px solid rgb(237, 188, 69)",
                  padding: "20px",
                  zIndex: 100000000, // Overlay'den yüksek olmalı
                  minWidth: "300px",
                }}
              >
                <Typography
                  variant="h6"
                  style={{
                    marginBottom: "1.5rem",
                    textAlign: "center",
                  }}
                >
                  {popup.title}
                </Typography>
                <div
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    gap: "10%",
                  }}
                  className="calisdur-popup"
                >
                  <Typography variant="subtitle1">Çalış Dur Komutu</Typography>
                  <FormControl variant="outlined" style={{ width: "100%" }}>
                    <select
                      value={popup.calisDurumu}
                      onChange={handleCalisDurumuChange}
                      style={{
                        fontWeight: 600,
                        border: "2px solid rgb(237, 188, 69)",
                        padding: "5%",
                        textAlign: "center",
                        fontSize: "1rem",
                      }}
                    >
                      <option value="1">ON</option>
                      <option value="0">OFF</option>
                    </select>
                  </FormControl>
                </div>
                <div
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    gap: "7%",
                  }}
                >
                  <Typography variant="subtitle1">
                    Su Çıkış Set Değeri
                  </Typography>
                  <FormControl
                    className="setdeger-popup"
                    style={{
                      width: "100%",
                      border: "2px solid rgb(237, 188, 69) !important",
                    }}
                  >
                    <Input
                      type="number"
                      value={popup.SuCikisSetDegeri}
                      onChange={handleSuCikisSetDegeriChange}
                      sx={{ fontWeight: 600 }}
                      style={{ textAlign: "center" }}
                      inputProps={{ min: 0, step: 1 }}
                    />
                  </FormControl>
                </div>
                {/* Değişiklikleri Kaydet kısmı sadece değişiklik olduğunda görünür */}
                {(popup.calisDurumu !== popup.originalCalisDurumu ||
                  popup.SuCikisSetDegeri !==
                    popup.originalSuCikisSetDegeri) && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "10px",
                      marginTop: "20px",
                    }}
                  >
                    <Typography
                      variant="button"
                      style={{
                        padding: "10px",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Değişiklikleri Kaydet
                    </Typography>
                    <IconButton aria-label="check" onClick={handleSaveChange}>
                      <DoneIcon className="popup-done" />
                    </IconButton>
                    <IconButton
                      onClick={handleCancelChanges}
                      aria-label="cancel"
                    >
                      <CloseIcon className="popup-cancel" />
                    </IconButton>
                  </div>
                )}
                <IconButton
                  style={{ position: "absolute", top: "2%", right: "2%" }}
                  aria-label="close"
                  onClick={closePopup}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

const MapStateToProps = (state) => {
  return {
    pages_: state.project_reducer.pages,
    tag_ids: state.project_reducer.tag_ids,
    tag_values: state.project_reducer.tag_values,
    user_id: state.auth_reducer.user_id,
    company_id: state.project_reducer.company_id,
    tag_list: state.project_reducer.tag_list,
    white_space_: state.project_reducer.white_space_items,
    fetch_tag_value_control: state.project_reducer.fetch_tag_value_control,
    booster_tags: state.project_reducer.booster_tags,
    booster_tags2: state.project_reducer.booster_calis_dur_komut_list,
  };
};
export default connect(MapStateToProps)(Booster);
